export default __webpack_public_path__ + "static/media/zenodot.a658a77e.png";